import { isSuperAdminTenant } from '../../utils/superAdminTenant'

/** @type {{id: string, label: string}} */
const STATUS_TAB = { id: 'status', label: 'Status & gezondheid' }

/** @type {Array<{id: string, label: string}>} */
const MANAGEMENT_TABS = [
    { id: 'tasks', label: 'Taken' },
    { id: 'notes', label: 'Notities' },
    { id: 'requests', label: 'Updateverzoeken' },
]

/**
 * Welke tabbladen de projectdetailpagina toont.
 *
 * Afspraken en notities zijn beheerwerk van Deccos zelf: ze leven in de
 * beheeromgeving en gaan over hoe het met een klant loopt. Een portfoliobeheerder
 * ziet daarom alleen de status van zijn projecten.
 *
 * Updateverzoeken zijn een uitzondering op die herkomst: die leven in de
 * KLANT-omgeving en worden cross-tenant gelezen. Ze staan hier omdat ze,
 * net als de afspraken, gaan over hoe het met die klant loopt.
 *
 * AI-CONTEXT: See docs/features/deccos-projectafspraken.md
 * AI-CONTEXT: See docs/features/update-aanvragen.md
 *
 * @param {string} compagnyId - De omgeving waarin de gebruiker werkt
 * @returns {Array<{id: string, label: string}>}
 */
const projectDetailTabs = (compagnyId) => (isSuperAdminTenant(compagnyId)
    ? [STATUS_TAB, ...MANAGEMENT_TABS]
    : [STATUS_TAB])

export default projectDetailTabs
